module.exports = __webpack_public_path__ + "static/media/project-2.eddf45b2.jpg";